export class SearchGroupsAction {
  static readonly type = '[SearchGroups] SearchGroupsAction';

  constructor(
    public payload: {
      sportsSelected?: string[];
    } = {},
  ) {}
}
